var render = function render(_c, _vm) {
  return _c("div", { staticClass: "mx-md-4" }, [
    _c("div", { staticClass: "bg-white border-radius--light py-2" }, [
      _c("div", { staticClass: "row" }, [
        _vm._m(0),
        _c("div", { staticClass: "col-3 col-sm col-6" }, [
          _c(
            "span",
            { staticClass: "font-14 font-weight-normal color-secondary-6" },
            [_vm._v(" Estatus: ")]
          ),
          _c("p", { staticClass: "font-16 font-weight-normal color-black" }, [
            _vm._v(" " + _vm._s(_vm.props.value.status || "-") + " ")
          ])
        ]),
        _c("div", { staticClass: "col-3 col-sm col-6" }, [
          _c(
            "span",
            { staticClass: "font-14 font-weight-normal color-secondary-6" },
            [_vm._v(" Razón: ")]
          ),
          _c("p", { staticClass: "font-16 font-weight-normal color-black" }, [
            _vm._v(" " + _vm._s(_vm.props.value.reason || "-") + " ")
          ])
        ]),
        _c("div", { staticClass: "col-3 col-sm col-12" }, [
          _c(
            "span",
            { staticClass: "font-14 font-weight-normal color-secondary-6" },
            [_vm._v(" Comentario: ")]
          ),
          _c("p", { staticClass: "font-16 font-weight-normal color-black" }, [
            _vm._v(" " + _vm._s(_vm.props.value.comment || "-") + " ")
          ])
        ]),
        _c("div", { staticClass: "col-3 col-sm col-12" }, [
          _c(
            "span",
            { staticClass: "font-14 font-weight-normal color-secondary-6" },
            [_vm._v(" Fecha Cumplimiento: ")]
          ),
          _c("p", { staticClass: "font-16 font-weight-normal color-black" }, [
            _vm._v(" " + _vm._s(_vm._f("date")(_vm.props.value.date)) + " ")
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function(_c, _vm) {
    return _c("div", { staticClass: "col-md-12 mb-3" }, [
      _c("em", { staticClass: "fas fa-info-circle text-orange mr-1" }),
      _c("span", [_vm._v("Informe de Progreso")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }